import styled from 'styled-components';

import { Headline } from 'components/Headline';

const Wrapper = styled.div`
  display: grid;
  grid-template-areas:
    'image table'
    'cta cta';

  margin: 3rem 0;
`;

const ImageWrapper = styled.div`
  grid-area: image;

  cursor: pointer;
`;

const TableWrapper = styled.div`
  grid-area: table;

  width: 50rem;
`;

const Title = styled(Headline)`
  margin-bottom: 3rem;
`;

export { Wrapper, Title, ImageWrapper, TableWrapper };
